import styled from 'styled-components';

import { color, dimension } from '@creditornot/cb-ingredients/design-tokens';
import { InputAlert } from '@creditornot/cb-input';
import { MenuItemGroup } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import { Tag } from '@creditornot/cb-tag';

import { Stack } from '../Stack';

export const Root = 'div';

export const TagsContainer = styled.div`
  flex: 1 1 0%;
  align-self: stretch;
  min-width: 0;
  display: flex;
  flex-flow: row wrap;
  padding-inline-start: 6px;
  padding-block: 3px;
  align-items: center;
`;

export const StyledTag = styled(Tag)`
  border-radius: ${dimension.cornerRadiusSmall};
  margin-block: ${dimension.spaceNarrowXsmall};
  margin-inline-end: ${dimension.spaceNarrowSmall};
`;

export const Placeholder = styled.span`
  color: ${color.textSubdued};
  user-select: none;
  margin-left: ${dimension.spaceNarrowMedium};
`;

export const StyledPopover = styled(Popover)`
  overflow: hidden;
`;

export const StyledMenuItemGroup = styled(MenuItemGroup)`
  max-height: 332px;
  width: 100%;
  overflow-y: auto;
  padding: ${dimension.spaceRegularMedium};
`;

export const StyledInputAlert = styled(InputAlert)`
  margin-top: ${dimension.spaceRegularMedium};
`;

export const NoOptionsAvailable = styled.div`
  color: ${color.textSubdued};
  padding: ${dimension.spaceRegularXlarge};
  text-align: center;
`;

export const MultiSelectButtonsContainer = styled(Stack)`
  flex-direction: row;
  gap: ${dimension.spaceRegularMedium};
  align-items: center;
  padding: ${dimension.spaceRegularMedium};
`;

export const InputLabel = styled.label<{
  $open: boolean;
  $invalid?: boolean;
}>`
  display: flex;
  min-height: 36px;
  border: ${dimension.borderWidthThin} solid;
  border-radius: ${dimension.cornerRadiusMedium};
  transition: border-color 75ms ease-in;
  border-color: ${({ $open, $invalid }) => {
    return $open ? color.borderSelected : $invalid ? color.borderNegative : color.border;
  }};

  &:focus {
    border-color: ${color.borderSelected};
    outline: 0;
  }

  &:hover {
    border-color: ${({ $open }) => !$open && color.borderHovered};
  }

  &[aria-disabled='true'] {
    background-color: ${color.bgSurfaceDisabled};
    border-color: ${color.borderDisabled};
    color: ${color.textDisabled};
  }
`;

export const Actions = styled.div`
  align-items: center;
  display: flex;
  gap: ${dimension.spaceNarrowSmall};
  height: 34px;
  padding-inline-end: ${dimension.spaceRegularLarge};
`;
